<template>
  <svg :class="svgClass" v-bind="$attrs">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script lang="ts" setup>
import { computed } from "vue";
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  className: {
    type: String,
    default: ""
  }
});

const iconName = computed(() => {
  return `#icon-${props.name}`;
});
const svgClass = computed(() => {
  if (props.className) {
    return "svg-icon" + props.className;
  }
  return "svg-icon";
});
</script>

<script lang="ts">
export default {
  name: "SvgIcon"
};
</script>

<style lang="less" scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}
</style>
